import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const ZeroTolerancePolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  safetyOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Zero_Tolerance_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Zero Tolerance Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        To affirm {clientName || "the Company"}’s commitment to maintaining a safe, responsible, and professional work environment by enforcing a strict zero tolerance policy on alcohol, drugs, and mobile phone use while driving or operating company equipment.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and temporary workers operating vehicles, machinery, or representing the company in any capacity.
      </p>

      <h4 className="section-title">3. Prohibited Behaviours</h4>
      <ul>
        <li>Consumption or possession of alcohol while on duty or on company premises.</li>
        <li>Driving or operating company vehicles or equipment under the influence of alcohol or illegal drugs.</li>
        <li>Use of prescription drugs that may impair driving without notifying management.</li>
        <li>Texting, using a mobile phone, or any handheld device while driving or operating machinery, unless hands-free and legal.</li>
      </ul>

      <h4 className="section-title">4. UK Legal Intoxication Limits</h4>
      <p className="section-content">
        The legal alcohol limit for drivers in England, Wales and Northern Ireland is a blood alcohol concentration (BAC) of 80 milligrams of alcohol per 100 millilitres of blood (0.08%). In Scotland, the limit is lower at 50 milligrams per 100 millilitres (0.05%). Exceeding these limits is a criminal offence under UK law.
      </p>

      <h4 className="section-title">5. Company Zero Tolerance</h4>
      <p className="section-content">
        Regardless of legal limits, {clientName || "the Company"} maintains a ZERO TOLERANCE stance on alcohol and drug use, phone distraction while driving, and any behaviour that compromises safety and professionalism. Any breach of this policy will result in immediate disciplinary action, up to and including termination of employment and potential legal action.
      </p>

      <h4 className="section-title">6. Testing and Enforcement</h4>
      <p className="section-content">
        The company reserves the right to conduct random or reasonable suspicion drug and alcohol testing. Refusal to comply with testing or positive results will be treated as gross misconduct.
      </p>

      <h4 className="section-title">7. Support and Rehabilitation</h4>
      <p className="section-content">
        Employees struggling with substance misuse are encouraged to seek support through the company’s Employee Assistance Programmes or external professional services. The company may consider rehabilitation options on a case-by-case basis.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <p><strong>Human Resources:</strong> {hrContact || "[Insert Contact]"}</p>
      <p><strong>Safety Officer:</strong> {safetyOfficerContact || "[Insert Contact]"}</p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Zero Tolerance Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default ZeroTolerancePolicy;
